import { useEffect, useState } from 'react'

/**
 * Installation PWA (S36 — extrait de App.jsx, comportement inchange).
 * - Android/Desktop : capte `beforeinstallprompt`, expose prompt + refus 7 jours.
 * - iOS : pas d'evenement natif — detection UA + bandeau d'explication dedie.
 * Le rendu des bandeaux vit dans `components/PwaInstallBanners.jsx`.
 */
export default function usePwaInstall() {
  const [installPrompt, setInstallPrompt] = useState(null)
  const [showInstallBanner, setShowInstallBanner] = useState(false)
  const isStandalone = window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches

  useEffect(() => {
    // Ecouter l'evenement beforeinstallprompt (Chrome/Android)
    const handler = (e) => {
      e.preventDefault()
      setInstallPrompt(e)
      // Afficher le bandeau si pas deja refuse recemment
      const dismissed = localStorage.getItem('lyannaj-install-dismissed')
      if (!dismissed || Date.now() - Number(dismissed) > 7 * 24 * 60 * 60 * 1000) {
        setShowInstallBanner(true)
      }
    }
    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  const handleInstall = async () => {
    if (installPrompt) {
      installPrompt.prompt()
      const { outcome } = await installPrompt.userChoice
      if (outcome === 'accepted') {
        setShowInstallBanner(false)
        setInstallPrompt(null)
      }
    }
  }

  const dismissInstall = () => {
    setShowInstallBanner(false)
    localStorage.setItem('lyannaj-install-dismissed', String(Date.now()))
  }

  // Detection iOS (pas de beforeinstallprompt)
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  const showIOSBanner = isIOS && !isStandalone && !localStorage.getItem('lyannaj-install-dismissed-ios')

  const dismissIOSBanner = () => {
    localStorage.setItem('lyannaj-install-dismissed-ios', String(Date.now()))
    setShowInstallBanner(false) // force re-render
  }

  return {
    installPrompt, showInstallBanner, isStandalone, showIOSBanner,
    handleInstall, dismissInstall, dismissIOSBanner,
  }
}
